export const FormInput = {
  bindings: {
    errors: '<',
    form: '<',
    name: '@',
    minlength: '@',
    onUpdate: '&',
    pattern: '@',
    required: '@',
    type: '@',
    value: '<',
    isFocus: '<',
  },

  template: `
    <input class="form-control"
      ng-class="{
        'is-valid': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$valid,
        'is-invalid': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$invalid,
      }"
      id="{{ $ctrl.name }}"
      type="{{ $ctrl.type }}"
      name="{{ $ctrl.name }}"
      pattern="{{ $ctrl.pattern }}"
      minlength="{{ $ctrl.minlength }}"
      focus-if="$ctrl.isFocus"
      rb-select-all-on-focus="$ctrl.type === 'text'"
      ng-value="$ctrl.value"
      ng-model="$ctrl.form.data[$ctrl.name]"
      ng-init="$ctrl.form.data[$ctrl.name] = $ctrl.value"
      ng-required="{{ $ctrl.required }}"
      ng-change="$ctrl.onChange()"
      ng-attr-autocomplete="{{ ($ctrl.type === 'password') && 'new-password' || undefined }}">
    <form-errors
      field="$ctrl.form[$ctrl.name]"
      errors="$ctrl.errors">
    </form-errors>`,

  controller() {
    return {
      // For some reason ng-value is not updating ng-model when $ctrl.value
      // resolves. $onChanges is essentially doing this manually.
      $onChanges() {
        const field = this.form[this.name];

        if (this.value && field && !field.$viewValue) {
          field.$setViewValue(this.value);

          // minlength isn't validating on load.
          if (this.minlength) {
            const minlength = parseInt(this.minlength, 10);
            const length = this.value.toString().length;

            if (length >= minlength) {
              field.$setValidity('minlength', true);
            }
          }
        }
      },

      // The $setViewValue within $onChanges will fire the ng-change so only
      // call onUpdate when $ctrl.value has actually changed.
      onChange() {
        const key = this.name;
        const value = this.form.data[this.name];
        const field = this.form[this.name];

        if (field.$valid && value !== this.value) {
          this.onUpdate({ key, value });
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormInput.js